<p *ngIf="ShowTimer && formattedTime !== '15:00' && formattedTime !== '00:00'" class="session_timer"> {{formattedTime}} </p>